import { useState } from "react";
import type {
  TemplateInformation,
  TemplateTestResultItem,
} from "../types/api-types";
import { testTemplate } from "../services/template-service";
import useTemplates from "./use-templates";

const useTemplateTest = () => {
  const { templates } = useTemplates();
  const [selectedTemplate, setSelectedTemplate] =
    useState<TemplateInformation | null>(null);
  const [inputData, setInputData] = useState("");
  const [results, setResults] = useState<TemplateTestResultItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleTemplateChange = (
    _event: React.SyntheticEvent,
    newValue: TemplateInformation | null,
  ) => {
    setSelectedTemplate(newValue);
    setResults([]);
    setError(null);
  };

  const handleSubmit = async () => {
    if (!selectedTemplate || !inputData.trim()) {
      setError("Please select a template and enter data to test");
      setResults([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const testValues = inputData
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      const response = await testTemplate(selectedTemplate.id, testValues);
      setResults(response.results);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to test template");
      setResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    templates,
    selectedTemplate,
    inputData,
    results,
    isLoading,
    error,
    setInputData,
    handleTemplateChange,
    handleSubmit,
  };
};

export default useTemplateTest;
